import React, { useEffect, useRef, useState } from 'react';
import { useFormGeneratorField } from '../hooks/useFormGeneratorField';
import UniFormcompoErrorInField from './UniFormcompoErrorInField';

const UniFormgenSpecialStars5 = (props) => {
  // const timeoutRef = useRef(null);
  // const [clAnimation, setClAnimation] = useState("");

  const {
    warningtip,
    // valueToDisplay,
  } = useFormGeneratorField(props);

  //
  let params = {};
  if (props.params) {
    params = props.params;
  }
  let disabled = false;
  if (params.disabled === true) {
    disabled = true;
  }
  let readonly = false;
  if (params.readonly === true) {
    readonly = true;
    disabled = true; //
  }
  let name = 'unnamed';
  if (typeof params.name === 'string' && params.name !== '') {
    name = params.name;
  }
  let formState = {};
  if (props.formState) {
    formState = props.formState;
  }
  let formErrors = {};
  if (props.formErrors) {
    formErrors = props.formErrors;
  }

  /*
  useEffect(() => {
    // animate when value change
    setClAnimation(" uniformcompo__field--animate-value-changed");
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    timeoutRef.current = setTimeout(() => {
      //
      setClAnimation("");
    }, 334);
    // componentWillUnmount
    return () => clearTimeout(timeoutRef.current);
  }, [formState[name]]);
  */

  let handleChange = null;
  if (typeof props.handleChange === 'function') {
    handleChange = props.handleChange;
  }
  if (readonly === true) {
    // FIX (According to HTML specs, the select tag in HTML doesn't have a readonly attribute, only a disabled attribute.)
    // handleChange = () => { }; // disable handle change for readonly
    handleChange = null; // disable handle change for readonly
  }

  /*
  let _handleChange = (e) => {
    // console.log('*** menjamo SELECT');
    if (params.valuetype === "number") {
      let _value;
      if (params.integer === true) {
        _value = Number.parseInt(e.target.value); // INTEGER
      } else {
        _value = Number.parseFloat(e.target.value); // FLOAT DEFAULT
      }
      let virtual_e = {
        target: {
          name: e.target.name,
          value: _value
        }
      }
      // console.log(virtual_e);
      handleChange(virtual_e);
    } else { // regular handleChange
      // console.log(e);
      handleChange(e);
    }
  }
  */

  let extraClass = '';
  if (typeof params.extraclass === 'string' && params.extraclass !== '') {
    extraClass = ' ' + params.extraclass;
  }

  // let cl = 'uniformcompo__field' + clAnimation + extraClass;
  let cl = 'uniformcompo__field' + extraClass;
  if (typeof formErrors[name] === 'string' && formErrors[name] !== '') {
    cl += ' error';
  }

  let style = {};
  if (params.w > 0) {
    style.width = params.w;
  }

  let tooltip = null;
  if (typeof params.tooltip === 'string' && params.tooltip !== '') {
    tooltip = params.tooltip;
  }

  let infotip = 'name: ' + name;

  //
  //
  const _handleClickStar = (_value) => {
    // value = Number.parseInt(e.target.value); // INTEGER
    // value = Number.parseFloat(e.target.value); // FLOAT DEFAULT
    const value = Number.parseInt(_value); // INTEGER
    let virtual_e = {
      target: {
        name: name,
        value: value
      }
    }
    handleChange(virtual_e);
  };
  const value = formState[name];

  return (
    <div className={cl} style={style}>
      <label htmlFor={name}>{params.label}</label>
      <UniFormcompoErrorInField error={formErrors[name]} />
      <div className="uniformcompo__field__infotip-container"><div className="uniformcompo__field__infotip">{infotip}</div></div>
      {
        warningtip ? (
          <div className="uniformcompo__field__warningtip-container"><div className={"uniformcompo__field__warningtip" + (" frfr-js-tinytag frfr-js-tinytag--primitive-value-type--" + warningtip)}>{warningtip}</div></div>
        ) : null
      }

      <div className="uniformcompo__widget-stars5">
        <div className={"uniformcompo__widget-stars5__star" + (value > 0 ? " uniformcompo__widget-stars5__star--active" : "")} onClick={(e) => { e.stopPropagation(); _handleClickStar(1) }}><i className="fa fa-star" aria-hidden="true"></i>
          <div className={"uniformcompo__widget-stars5__star" + (value > 1 ? " uniformcompo__widget-stars5__star--active" : "")} onClick={(e) => { e.stopPropagation(); _handleClickStar(2) }}><i className="fa fa-star" aria-hidden="true"></i>
            <div className={"uniformcompo__widget-stars5__star" + (value > 2 ? " uniformcompo__widget-stars5__star--active" : "")} onClick={(e) => { e.stopPropagation(); _handleClickStar(3) }}><i className="fa fa-star" aria-hidden="true"></i>
              <div className={"uniformcompo__widget-stars5__star" + (value > 3 ? " uniformcompo__widget-stars5__star--active" : "")} onClick={(e) => { e.stopPropagation(); _handleClickStar(4) }}><i className="fa fa-star" aria-hidden="true"></i>
                <div className={"uniformcompo__widget-stars5__star" + (value > 4 ? " uniformcompo__widget-stars5__star--active" : "")} onClick={(e) => { e.stopPropagation(); _handleClickStar(5) }}><i className="fa fa-star" aria-hidden="true"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  );
};

export default UniFormgenSpecialStars5;